import { Button } from '@fluentui/react-components'
import { ArrowClockwise20Regular } from '@fluentui/react-icons'
import type { FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { ErrorPageLayout } from '../ErrorPageLayout/ErrorPageLayout'

export const ErrorFallback = ({ resetErrorBoundary }: FallbackProps) => {
  const { t } = useTranslation()

  return (
    <ErrorPageLayout title={t('errorBoundary.title')} body={t('errorBoundary.body')}>
      <Button appearance="primary" icon={<ArrowClockwise20Regular />} onClick={resetErrorBoundary}>
        {t('errorBoundary.refresh')}
      </Button>
    </ErrorPageLayout>
  )
}
